/* WW1991 Street — Theme JavaScript */

(function() {
  'use strict';

  /* ─ Helpers ─ */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' NIS';
  }

  /* ─ Nav badge ─ */
  function setBadge(selector, n) {
    document.querySelectorAll(selector).forEach(function(el) {
      if (n <= 0) { el.style.display = 'none'; el.textContent = '0'; }
      else { el.textContent = n > 9 ? '9+' : String(n); el.style.display = 'flex'; }
    });
  }

  /* ─ Cart toast ─ */
  var cartToast = null;
  var cartToastTimer = null;

  function buildCartToast() {
    if (cartToast) return;
    cartToast = document.createElement('div');
    cartToast.className = 'cart-toast';
    cartToast.innerHTML =
      '<div class="cart-toast__thumb-wrap" id="ct-thumb-wrap"><div class="cart-toast__thumb-placeholder"></div></div>'
      + '<div class="cart-toast__body"><span class="cart-toast__label">ADDED TO BAG</span><span class="cart-toast__title" id="ct-title"></span><span class="cart-toast__sub" id="ct-sub"></span></div>'
      + '<div class="cart-toast__actions"><a class="cart-toast__view" href="/cart">VIEW BAG</a><button class="cart-toast__close" id="ct-close" aria-label="Close">&#x2715;</button></div>';
    document.body.appendChild(cartToast);
    document.getElementById('ct-close').addEventListener('click', hideCartToast);
  }

  function showCartToast(data) {
    buildCartToast();
    clearTimeout(cartToastTimer);
    document.getElementById('ct-title').textContent = data.title || '';
    document.getElementById('ct-sub').textContent   = data.price || '';
    var wrap = document.getElementById('ct-thumb-wrap');
    wrap.innerHTML = data.image
      ? '<img class="cart-toast__thumb" src="' + data.image + '" alt="' + (data.title||'') + '">'
      : '<div class="cart-toast__thumb-placeholder"></div>';
    cartToast.classList.remove('open');
    requestAnimationFrame(function() { requestAnimationFrame(function() { cartToast.classList.add('open'); }); });
    cartToastTimer = setTimeout(hideCartToast, 3200);
  }

  function hideCartToast() { if (cartToast) cartToast.classList.remove('open'); }

  /* ───────────────────────────────────────
     LIVE CART DRAWER
     All mutations (add / remove / qty / clear) hit
     the Shopify Cart API and re-render the drawer
     without any page reload.
  ─────────────────────────────────────── */

  function fetchCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function renderCartDrawer(cart) {
    var itemsEl    = document.querySelector('.cart-drawer__items');
    var footerEl   = document.querySelector('.cart-drawer__footer');
    var titleCount = document.querySelector('.cart-drawer__title span');
    if (!itemsEl) return;

    /* update nav badge */
    setBadge('.cart-count', cart.item_count);

    /* update title count */
    if (titleCount) titleCount.textContent = '(' + cart.item_count + ')';

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<p style="color:var(--muted);font-size:0.8rem;letter-spacing:0.1em;margin-top:3rem;text-align:center;font-family:var(--font-condensed);text-transform:uppercase;">Your bag is empty</p>'
        + '<div style="text-align:center;margin-top:1.5rem;"><a href="/collections/all" class="btn btn--primary" style="display:inline-block;">Shop Now</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    /* render items */
    var html = '';
    cart.items.forEach(function(item) {
      var img = item.image ? item.image.replace('http:', 'https:') : '';
      html +=
        '<div class="cart-item" data-key="' + item.key + '">'
          + '<a href="' + item.url + '">'
            + (img ? '<img class="cart-item__img" src="' + img + '" alt="' + item.title + '" loading="lazy" width="80" height="100">' : '')
          + '</a>'
          + '<div class="cart-item__details">'
            + '<p class="cart-item__name">' + item.product_title + '</p>'
            + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '')
            + '<p class="cart-item__price">' + formatMoney(item.price) + '</p>'
            + '<div class="cart-item__qty">'
              + '<button class="qty-btn" data-key="' + item.key + '" data-dir="down" aria-label="Decrease quantity">&#8722;</button>'
              + '<span class="qty-val">' + item.quantity + '</span>'
              + '<button class="qty-btn" data-key="' + item.key + '" data-dir="up" aria-label="Increase quantity">&#43;</button>'
            + '</div>'
          + '</div>'
          + '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove ' + item.product_title + ' from cart">&#x2715;</button>'
        + '</div>';
    });
    itemsEl.innerHTML = html;

    /* footer */
    if (footerEl) {
      footerEl.style.display = '';
      var subtotalEl = footerEl.querySelector('.cart-subtotal__val');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }

    /* re-bind item controls */
    bindCartControls();
  }

  function updateCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) { return r.json(); }).then(renderCartDrawer);
  }

  function clearCart() {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function(r) { return r.json(); })
      .then(renderCartDrawer);
  }

  function bindCartControls() {
    /* qty buttons */
    document.querySelectorAll('.qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.key;
        var dir = this.dataset.dir;
        var val = parseInt(this.closest('.cart-item__qty').querySelector('.qty-val').textContent);
        var newQty = dir === 'up' ? val + 1 : Math.max(0, val - 1);
        updateCartItem(key, newQty);
      });
    });

    /* remove single item */
    document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.key;
        var item = this.closest('.cart-item');
        /* animate out */
        item.style.transition = 'opacity 0.2s, transform 0.2s';
        item.style.opacity = '0';
        item.style.transform = 'translateX(20px)';
        setTimeout(function() { updateCartItem(key, 0); }, 200);
      });
    });

    /* clear all */
    var clearBtn = document.getElementById('cart-clear-btn');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (confirm('Empty your entire bag?')) clearCart();
      });
    }
  }

  /* ─ AJAX add-to-cart ─ */
  function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      fetchCart().then(function(cart) {
        setBadge('.cart-count', cart.item_count);
        renderCartDrawer(cart);
      });
      showCartToast({
        title: item.product_title || item.title || '',
        price: formatMoney(item.price),
        image: item.image || ''
      });
      if (btn) {
        btn.textContent = 'ADDED ✓';
        setTimeout(function() { btn.disabled = false; btn.textContent = origText; }, 1800);
      }
    })
    .catch(function() { if (btn) { btn.disabled = false; btn.textContent = origText; } });
  }

  function initAjaxCart() {
    var form = document.getElementById('product-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var id  = (form.querySelector('[name="id"]') || {}).value;
        var btn = form.querySelector('button[type="submit"]');
        addToCart(id, 1, btn);
      });
    }
    document.querySelectorAll('.product-card__quick-add').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var card   = btn.closest('.product-card');
        var wBtn   = card && card.querySelector('[data-product-handle]');
        var handle = wBtn && wBtn.dataset.productHandle;
        if (!handle) return;
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            var variant = p.variants && p.variants[0];
            if (variant && variant.available) { addToCart(variant.id, 1, btn); }
            else { window.location.href = '/products/' + handle; }
          });
      });
    });
  }

  /* ─ Scroll Reveal ─ */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { io.observe(el); });
  }

  /* ─ Sticky Nav Shadow ─ */
  function initNavScroll() {
    var nav = document.querySelector('.site-nav');
    if (!nav) return;
    window.addEventListener('scroll', function() {
      nav.style.boxShadow = window.scrollY > 10 ? '0 4px 30px rgba(0,0,0,0.5)' : 'none';
    }, { passive: true });
  }

  /* ─ Mobile Menu ─ */
  function initMobileMenu() {
    var trigger = document.querySelector('.nav-hamburger');
    var menu    = document.querySelector('.mobile-menu');
    if (!trigger || !menu) return;
    trigger.addEventListener('click', function() {
      var open = menu.classList.toggle('open');
      trigger.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    menu.querySelectorAll('.mobile-menu__link').forEach(function(link) {
      link.addEventListener('click', function() {
        menu.classList.remove('open'); trigger.classList.remove('open'); document.body.style.overflow = '';
      });
    });
  }

  /* ─ Cart Drawer open/close ─ */
  function initCartDrawer() {
    var cartDrawer  = document.querySelector('.cart-drawer');
    var cartOverlay = document.querySelector('.cart-drawer__overlay');
    var cartClose   = document.querySelector('.cart-drawer__close');
    var cartTriggers = document.querySelectorAll('[data-cart-trigger]');
    if (!cartDrawer) return;

    function openCart() {
      /* always fetch fresh cart state when opening */
      fetchCart().then(renderCartDrawer);
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeCart() {
      cartDrawer.classList.remove('open');
      cartOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    cartTriggers.forEach(function(t) { t.addEventListener('click', function(e) { e.preventDefault(); openCart(); }); });
    if (cartClose)   cartClose.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    /* initial bind for server-rendered items */
    bindCartControls();
  }

  /* ─ Accordion ─ */
  function initAccordion() {
    document.querySelectorAll('.accordion__trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item    = this.closest('.accordion__item');
        var content = item.querySelector('.accordion__content');
        var isOpen  = item.classList.contains('open');
        document.querySelectorAll('.accordion__item').forEach(function(i) {
          i.classList.remove('open');
          i.querySelector('.accordion__content').style.maxHeight = null;
        });
        if (!isOpen) { item.classList.add('open'); content.style.maxHeight = content.scrollHeight + 'px'; }
      });
    });
  }

  /* ─ Product Gallery ─ */
  function initProductGallery() {
    var thumbs  = document.querySelectorAll('.product-gallery__thumb');
    var mainImg = document.querySelector('.product-gallery__main img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        mainImg.src = this.querySelector('img').src;
      });
    });
  }

  /* ─ Size Selector ─ */
  function initSizeSelector() {
    document.querySelectorAll('.size-btn:not(.unavailable)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.closest('.size-grid').querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ─ Filter Tabs ─ */
  function initFilterTabs() {
    document.querySelectorAll('.filter-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        this.closest('.filter-bar').querySelectorAll('.filter-tab').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ─ Cursor FX ─ */
  function initCursor() {
    if (window.innerWidth < 1024) return;
    var cursor = document.createElement('div');
    cursor.style.cssText = 'position:fixed;pointer-events:none;z-index:9999;width:6px;height:6px;border-radius:50%;background:#a2302b;transform:translate(-50%,-50%);transition:width .3s,height .3s,opacity .3s;top:0;left:0;';
    var ring = document.createElement('div');
    ring.style.cssText = 'position:fixed;pointer-events:none;z-index:9998;width:32px;height:32px;border-radius:50%;border:1px solid #a2302b;transform:translate(-50%,-50%);transition:width .4s,height .4s,left .12s,top .12s,opacity .3s;top:0;left:0;';
    document.body.appendChild(cursor);
    document.body.appendChild(ring);
    document.addEventListener('mousemove', function(e) {
      cursor.style.left = e.clientX + 'px'; cursor.style.top = e.clientY + 'px';
      ring.style.left   = e.clientX + 'px'; ring.style.top   = e.clientY + 'px';
    });
    document.querySelectorAll('a,button,.product-card,.size-btn').forEach(function(el) {
      el.addEventListener('mouseenter', function() { cursor.style.width='7px';cursor.style.height='7px';ring.style.width='40px';ring.style.height='40px'; });
      el.addEventListener('mouseleave', function() { cursor.style.width='5px';cursor.style.height='5px';ring.style.width='28px';ring.style.height='28px'; });
    });
  }

  /* ─ Boot ─ */
  document.addEventListener('DOMContentLoaded', function() {
    initReveal();
    initNavScroll();
    initMobileMenu();
    initCartDrawer();
    initAccordion();
    initProductGallery();
    initSizeSelector();
    initFilterTabs();
    initAjaxCart();
    initCursor();
  });

})();
